import { getAssetIconBySymbol } from 'abis/set/asset-icons'
import type { ProductMetadata } from 'indices-list'
import type React from 'react'
import {
  BgWrapper,
  CustomIcon,
  DescriptionText,
  GradientTextWrapper,
  IndexInfo,
  LogoWrapper,
  RegularText,
  TextWrapper,
  Title,
} from './styled'

interface CoverProps {
  productMetadata: ProductMetadata
  tagLine: string
}

export const Cover: React.FC<CoverProps> = ({ productMetadata, tagLine }) => {
  const { longName, symbol } = productMetadata

  const regularText = tagLine

  return (
    <>
      <BgWrapper>
        <LogoWrapper>
          <CustomIcon src={getAssetIconBySymbol(productMetadata.symbol.toUpperCase())} />
        </LogoWrapper>
        <TextWrapper>
          <Title>{symbol.toUpperCase()}</Title>
          <IndexInfo>{`| ${longName}`}</IndexInfo>
        </TextWrapper>
      </BgWrapper>
      {symbol !== 'artxai' ? (
        <>
          <RegularText>{regularText}</RegularText>
        </>
      ) : (
        <GradientTextWrapper>
          <RegularText style={{ marginRight: '5px' }}>{regularText}</RegularText>
        </GradientTextWrapper>
      )}

      <DescriptionText>{productMetadata.description}</DescriptionText>
    </>
  )
}
